import React from 'react';
import classnames from 'classnames';

import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { withError, withValidation } from '@bingads-webui-react/validation';
import { withControlErrorHandling, withUnvalidatedControlErrors } from '@bingads-webui-campaign-react/error-handling';
import { TextField } from '@bingads-webui-react/fluent-controls';

import { getTextInputContainerStyles } from './style';
import { withRemainingChars } from './with-remaining-chars';

const ValidatedTextField = withValidation(TextField);

const RemainingCharsValidatedTextFieldInternal = withControlErrorHandling(withUnvalidatedControlErrors(withError(withRemainingChars(ValidatedTextField))));

export const RemainingCharsValidatedTextField = React.memo((props) => {
  const classes = useDefaultStyles(getTextInputContainerStyles);

  return (
    <div className={classnames('text-input-container', classes.TextInputContainer)}>
      <RemainingCharsValidatedTextFieldInternal {...props} />
    </div>
  );
});
